import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgEmpty = function SvgEmpty(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_70_24959",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_70_24959)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_70_24959)",
        fillOpacity: 0.16,
        d: "M18.68 76.92q1.347 1.347 3.269 1.347H66.05q1.921 0 3.269-1.347 1.347-1.347 1.347-3.269V29.55q0-1.921-1.347-3.269-1.347-1.347-3.269-1.347H21.95q-1.921 0-3.269 1.347-1.347 1.347-1.347 3.269V73.65q0 1.921 1.347 3.269"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_70_24959)",
        fillRule: "evenodd",
        d: "M38.868 9.552q.356.366.912.366t.926-.366.37-.916V2.482q0-.55-.355-.916t-.912-.366-.926.366-.37.916v6.154q0 .55.355.916m-22.881 2.007 4.27 4.27q.365.41.884.419a1.4 1.4 0 0 0 .949-.356q.365-.412.323-.94a1.64 1.64 0 0 0-.323-.893l-4.27-4.27q-.43-.429-.926-.429t-.896.43q-.396.365-.398.916-.003.552.387.853M57.5 15.931a1.14 1.14 0 0 1-.42-.885q-.009-.538.42-.968l4.288-4.288q.366-.346.893-.379.528-.03.94.398.43.43.43.917 0 .486-.43.916l-4.288 4.289q-.346.345-.916.346-.57 0-.917-.346M14.68 72.92q1.347 1.347 3.269 1.347H62.05q1.921 0 3.269-1.347 1.347-1.347 1.347-3.269V25.55q0-1.921-1.347-3.269-1.347-1.347-3.269-1.347H17.95q-1.921 0-3.269 1.347-1.347 1.347-1.347 3.269V69.65q0 1.921 1.347 3.269m47.371-1.217H17.95q-.898 0-1.475-.577t-.577-1.475v-9.859h12.936q1.654 3.27 4.696 5.03 3.04 1.758 6.458 1.759 3.416 0 6.471-1.76t4.709-5.029h12.936v9.86q0 .898-.577 1.474t-1.475.577m-16.868-9.08a10.1 10.1 0 0 1-5.17 1.394q-2.778 0-5.183-1.395a8.94 8.94 0 0 1-3.631-3.913 2.43 2.43 0 0 0-1.35-1.157 5.3 5.3 0 0 0-1.83-.324H15.897v-31.68q0-.897.577-1.474.577-.576 1.475-.577H62.05q.898 0 1.475.577.576.577.577 1.475v31.68H52.026q-.982 0-1.875.323a2.43 2.43 0 0 0-1.35 1.157q-1.224 2.52-3.618 3.913",
        clipRule: "evenodd"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_70_24959",
        x1: 17.89,
        x2: 69.924,
        y1: 51.6,
        y2: 51.6,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_70_24959",
        x1: 13.89,
        x2: 65.924,
        y1: 37.733,
        y2: 37.733,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgEmpty as ReactComponent };
//# sourceMappingURL=Empty.svg.es.js.map
